import { useContext, useState } from "react"
import { notify } from "../../utils/utils";
import { UserContext } from "../../context/provider/UserProvider";
import { Fetch } from "../../services/api";

const urlIncidencia = process.env.REACT_APP_XPROJECT_API + "/Incidence";
const urlIncidenciaPGI = process.env.REACT_APP_PGI_API + "/Incidence";
const urlIncidenciaProcesoPGI = process.env.REACT_APP_PGI_API + "/Processes";
const urlIncidenciaGeneralPGI = process.env.REACT_APP_PGI_API + "/General";
const urlIncidenciaConcepto = process.env.REACT_APP_PGI_API + "/Concept";

export const useIncidencias = () => {
    const participantesDefault = {
        codUsuarioParticipanteConcatenado: '',

    }
    
    const detalleDefault = {
        tituloIncidencia: "",
        descripcionIncidencia: "",
        codProductoInterno: 0,
        nomProductoInterno: "",
        padronUnidad: "",
        placaUnidad: "",
        codEmpresaGeneral: 0,
        nomEmpresa: "",
        uidCreacion: "",
        fechaHoraCreacion: "",
        codIncidenciaConcepto: 0,
        nomIncidenciaConcepto: "",
        versionEnquipo: "",
        modeloEquipo: "",
        vigenciaEquipo: "",
        nroOrdenActual: ""
    };
    
    const validacionDefault = {
        codUrgencia: 0,
        comentarioAtencion: "",
        codIncidenciaConcepto: 0,
        solucionado: false,
        codIncidenciaTipoCierre: 0,
        comentarioCierre: "",
        motivoIncidencia: ""
    };

    const solucionDefault = {
        causaIncidencia: '',
        comentarioSolucion: ''
    };

    const resolverIncidenciaDefault = {
        fechaHoraInicioAtencion: "",
        uidSolucionConcatenado: "",
        causaIncidencia: "",
        comentarioSolucion: "",
        segundosTotalAtencion: 0,
    };

    const seguimientoIncidenciaDefault = {
        codIncidencia: 0,
        codEstado: 0,
        codIncidenciaSeguimiento: 0,
        descripcion: "",
        fechaCreacion: "",
        nomEstado: "",
        nomUsuarioCreacion: ""
    }


    const { stateUser } = useContext(UserContext);
    const [ incidencias, setIncidencias ] = useState([]);
    const [ loading, setLoading ] = useState(false);
    const [ participantes, setParticipantes ] = useState(participantesDefault);
    const [ detalleIncidencia, setDetalleIncidencia ] = useState(detalleDefault);
    const [ imagenesDetalle, setImagenesDetalle ] = useState([]);
    const [ datosValidacion, setDatosValidacion ] = useState(validacionDefault)
    const [ imagenesValidacion, setImagenesValidacion ] = useState([]);
    const [ documentosValidacion, setDocumentosValidacion ] = useState([]);
    const [ tipoUrgencia, setTipoUrgencia ] = useState([]);
    const [ conceptosIncidencia, setConceptosIncidencia ] = useState([]);
    const [ resolucion, setResolucion ] = useState(resolverIncidenciaDefault)
    const [ solucion, setSolucion ] = useState(solucionDefault);


    
    const [ nuevoSeguimientoIncidencia, setNuevoSeguimientoIncidencia ] = useState(seguimientoIncidenciaDefault);
    const [ seguimientosIncidencia, setSeguimientosIncidencia ] = useState([]);

    

    const listarIncidencias = async (fechaInicio, fechaFin, codigoEstado, codigoParticipante, codigoUrgencia, codigoEmpresa) => {
        try{
            setLoading(true);
            const response = await Fetch({url: urlIncidencia + '/incidentList?' + new URLSearchParams({
                CodArea: stateUser.codAreaActual,
                FechaInicio: fechaInicio,
                FechaFin: fechaFin,
                CodEstado: codigoEstado || 0,
                UIDAccion: codigoParticipante,
                CodUrgencia: codigoUrgencia,
                CodEmpresa: codigoEmpresa
            })});
            !response.isValid && notify(response.exceptions[0].description);
            setIncidencias(response.isValid ? response.content: []);
        }
        catch(e){
            notify('Ocurrió un error en el servicio','error');
            setIncidencias([]);
            console.log('Error al listar incidencias: ',e);
        }
        finally{
            setLoading(false);
        }
    }

    const listarDetalleIncidencia = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaPGI + '/detail?' + new URLSearchParams({
                    CodIncidencia: codIncidencia
                })
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            if(response.isValid){
                response.content.detalleIncidencia.codIncidencia = codIncidencia;
                setDetalleIncidencia(response.content.detalleIncidencia);
                setImagenesDetalle(response.content.detalleIncidencia.listaImagenesTgps || [] );
                setDatosValidacion(response.content.validacionIncidencia);
                setImagenesValidacion(response.content.validacionIncidencia.listaImagenesValidacion || []);
                setDocumentosValidacion(response.content.validacionIncidencia.listaDocumentosValidacion || []);
                setResolucion(response.content.resolucionIncidencia|| resolverIncidenciaDefault);
            }
            else{
                setDetalleIncidencia(detalleDefault);
                setImagenesDetalle([]);
                setDatosValidacion(validacionDefault);
                setImagenesValidacion([]);
                setDocumentosValidacion([]);
                setResolucion(resolverIncidenciaDefault);
            }
        }
        catch(error){
            console.log('Error al listar detalle: ',error);
            notify('Ocurrió un error en el servicio','error');
            setDetalleIncidencia(detalleDefault);
            setImagenesDetalle([]);
            setDatosValidacion(validacionDefault);
            setImagenesValidacion([]);
            setDocumentosValidacion([]);
        }

    }

    const listarTipoUrgencia = async () => {
        try{
            const response = await Fetch({url: urlIncidenciaGeneralPGI + '/typeEmergency'});
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setTipoUrgencia(response.isValid ? response.content : []);
        }
        catch(error){
            setTipoUrgencia([]);
            notify('Ocurrió un error: ' + error,'error');
        }
    }

    const listarConceptosIncidencia = async (codProductoInterno) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaConcepto + '?' + new URLSearchParams({
                    CodProductoInterno : codProductoInterno||0
                })
            });
            !response.isValid && notify(response.exceptions[0].description, 'error')
            setConceptosIncidencia(response.isValid ? response.content : [])

        }
        catch(e){
            setConceptosIncidencia([])
            notify('Ocurrió un error en el servicio','error');
            console.log('Error al listar',e)
        }
    }

    const guardarParticipantes = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidencia + '/assignParticipants',
                method: 'PUT',
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                    uidSolucion: participantes.codUsuarioParticipanteConcatenado.replaceAll(' ',''),
                    codIncidencia: codIncidencia
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description),response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(e){
            notify('Ocurrió un error en el servicio', 'error')
            console.log('Error al asignar participantes: ',e)
            return false;
        }
    }

    const editarValorParticipantes = (key, value) => {
        setParticipantes(inicio => {
            return {
                ...inicio,
                [key]: value
            }
        });
    }

    const guardarSolucion = async (codIncidencia) => {
        try{
            const response = await Fetch({
                url: urlIncidenciaProcesoPGI + '/registerSolution',
                method: 'PUT',
                body: JSON.stringify({
                    uidAccion: stateUser.nomUsuario.split('@')[0],
                    codIncidencia: codIncidencia,
                    causaIncidencia: solucion.causaIncidencia,
                    comentarioSolucion: solucion.comentarioSolucion,
                    dataArchivoS: []
                })
            });
            notify((response.isValid ? response.content : response.exceptions[0].description),response.isValid ? 'success' : 'error');
            return response.isValid;
        }
        catch(e){
            notify('Ocurrió un error en el servicio', 'error')
            console.log('Error al guardar solución: ',e)
            return false; 
        }
    }

    const editarValorSolucion = (key, value) => {
        setSolucion(inicio => {
            return {
                ...inicio,
                [key]: value
            }
        });
    }

    const resetSolucion = async () => {
        setSolucion(solucionDefault);
    }

    const listarSeguimientoTicketIncidencia = async (codTicket) => {
        try{
            const response = await Fetch({
                url: urlIncidencia + '/incidentTracking?' +  new URLSearchParams({
                    CodTicket: codTicket
                }),
                method: 'GET'
            })
            !response.isValid && notify(response.exceptions[0].description, 'error');
            setSeguimientosIncidencia(response.isValid ? response.content : []) 
        }
        catch(e){
            setSeguimientosIncidencia([]);
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar seguimiento por ticket: ',e);
        }
    }

    
    const editarValorNuevoSeguimientoIncidencia = (key, value) => {
        setNuevoSeguimientoIncidencia(seguimientoTicket => {
            return {
                ...seguimientoTicket,
                [key]: value
            }
        });
    }

    const editarValorSeguimientoIncidencia = (index, key, value) => {
        setSeguimientosIncidencia((seguimientos) =>
            seguimientos.map((seg, i) =>
                i === index
                    ? { ...seg, [key]: value } // Actualiza solo la tarea específica
                    : seg // Mantén las demás tareas sin cambios
            )
        );
    }

    const registrarSeguimientoIncidencia = async (indice) => {
        try{
            const esGuardar = indice === undefined ? true : false;
            const response = await Fetch({
                url: urlIncidencia + '/incidentTracking',
                method: esGuardar ? 'POST' : 'PUT',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    ...(esGuardar ?
                        { 
                            CodTicketIncidencia: nuevoSeguimientoIncidencia.codIncidencia,
                            Descripcion: nuevoSeguimientoIncidencia.descripcion,
                        }
                        :
                        {
                            CodTicketSeguimiento: seguimientosIncidencia[indice].codIncidenciaSeguimiento,
                            Descripcion: seguimientosIncidencia[indice].descripcion,
                        }
                    ),
                })
            });
            notify(response.isValid ? response.content : response.exceptions[0].description, (response.isValid ? 'success' : 'error'));
            return response.isValid;
        }
        catch(e){
            console.log('Error al registrar seguimiento: ',e)
            notify('Ocurrió un error en el servicio','error');
            return false;
        }
    }

    const eliminarSeguimientoIncidencia = async (codTicketSeguimiento) => {
        try{
            const response = await Fetch({
                url: urlIncidencia + '/incidentTracking',
                method: 'DELETE',
                body: JSON.stringify({
                    CodUsuarioAccion: stateUser.codUsuario,
                    CodTicketSeguimiento: codTicketSeguimiento
                })
            })
            notify((response.isValid ? response.content : response.exceptions[0].description ) , response.isValid ? 'success' : 'error');
            return response.isValid
        }
        catch(e){
            notify('Ocurrió un error en el servicio', 'error');
            console.log('Error al listar seguimiento por ticket: ',e);
        }
    }


    return{
        incidencias,
        listarIncidencias,
        editarValorParticipantes,
        guardarParticipantes,
        listarDetalleIncidencia,
        detalleIncidencia,
        imagenesDetalle,
        datosValidacion,
        imagenesValidacion,
        documentosValidacion,
        listarTipoUrgencia,
        tipoUrgencia,
        listarConceptosIncidencia,
        conceptosIncidencia,
        guardarSolucion,
        solucion,
        editarValorSolucion,
        resetSolucion,
        resolucion,
        loading,
        listarSeguimientoTicketIncidencia,
        seguimientosIncidencia,
        editarValorNuevoSeguimientoIncidencia,
        editarValorSeguimientoIncidencia,
        registrarSeguimientoIncidencia,
        eliminarSeguimientoIncidencia,
        nuevoSeguimientoIncidencia,
    }
}